import { render, staticRenderFns } from "./HeaderUpdateBtn.vue?vue&type=template&id=fedf6d1c"
import script from "./HeaderUpdateBtn.vue?vue&type=script&lang=js"
export * from "./HeaderUpdateBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports